export default __webpack_public_path__ + "static/media/demo.f0859d22.mp4";